export const ENV = {
  nodeEnv: process.env.NODE_ENV as 'production' | 'development',
  reactEnv: process.env.REACT_APP_ENV as 'staging' | 'production',
  baseApi: process.env.REACT_APP_BASE_API as string,
  versionApi: process.env.REACT_APP_VERSION_API as string,
  googleMapKey: process.env.REACT_APP_GOOGLE_MAP_KEY as string,
  versionApp: process.env.REACT_APP_VERSION_APP as string,
  templateExportPrescription: process.env
    .REACT_APP_TEMPLATE_IMPORT_PRESCRIPTION as string,
  templateImportGroupServices: process.env
    .REACT_APP_TEMPLATE_IMPORT_GROUP_SERVICES as string,
  socket: process.env.REACT_APP_SOCKET as string
}
